<template>
  <HiDatatable
    :headers="headers"
    :items="contacts"
    @select="selectRow"
    style="height:100%"
  ></HiDatatable>
</template>

<script>
import HiDatatable from "@/components/HiDatatable";

import { db } from "@/db";
export default {
  name: "ContactList",
  components: {
    HiDatatable
  },
  props: {},
  data() {
    return {
      selectedRow: null,
      headers: [
        {
          text: "Name",
          sortable: true,
          bold: true,
          capitalize: true,
          value: "name",
          renderer: item => {
            let text = item.name;
            if (item.surname) text += " " + item.surname;
            if (item.source) {
              text += `<div class="ui-text">${item.source}</div>`;
            }
            // if (this.isNew(item)) text += "(new)";
            return text;
          },
          width: "175px"
        },
        {
          text: "Phone",
          sortable: false,
          filterable: false,
          renderer: item => {
            /** @namespace item.phone **/
            return item.mobile || item.phone;
          },
          width: "150px"
        },
        {
          text: "Email",
          sortable: false,
          filterable: false,
          value: "email"
        }
      ],
      itemsPerPage: 25,
      contacts: []
    };
  },
  firestore: {
    contacts: db.collection("contacts")
  },
  methods: {
    selectRow(item) {
      this.$emit("select", item);
    }
  }
};
</script>

<style scoped></style>
